import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
export var Dogspaces;
(function (Dogspaces) {
    let Sizes;
    (function (Sizes) {
        Sizes["Small"] = "small";
        Sizes["Medium"] = "medium";
        Sizes["Large"] = "large";
        Sizes["XLarge"] = "x-large";
        Sizes["XXLarge"] = "xx-large";
    })(Sizes = Dogspaces.Sizes || (Dogspaces.Sizes = {}));
    Dogspaces.SizeTitle = {
        [Dogspaces.Sizes.Small]: 'Small',
        [Dogspaces.Sizes.Medium]: 'Medium',
        [Dogspaces.Sizes.Large]: 'Large',
        [Dogspaces.Sizes.XLarge]: 'X-Large',
        [Dogspaces.Sizes.XXLarge]: 'XX-Large'
    };
    Dogspaces.SizeSchema = z.union([
        z.literal(Sizes.Small),
        z.literal(Sizes.Medium),
        z.literal(Sizes.Large),
        z.literal(Sizes.XLarge),
        z.literal(Sizes.XXLarge),
    ]);
    Dogspaces.VaccineRefSchema = z.object({
        ref: z.string().min(1),
        expires: z.string().datetime()
    }).optional();
    const DogVaccines = {
        "vax-rabies": Dogspaces.VaccineRefSchema.describe('Rabies'),
        "vax-bordetella": Dogspaces.VaccineRefSchema.describe('Bordetella'),
        "vax-dhpp": Dogspaces.VaccineRefSchema.describe('DHPP'),
        "vax-parasite": Dogspaces.VaccineRefSchema.describe('Flea, Tick, Worm (Parasite) Control')
    };
    Dogspaces.Schema = z.object({
        /** Name of the dog */
        name: z.string({ description: "Dog Name" }).min(1),
        /** Breed of the dog */
        breed: z.string({ description: "Dog Breed" }).min(1),
        /** Who owns the dog, firebase auth uid */
        owner: z.string(),
        /** How heavy the dog is */
        weight: z.number({ description: "Dog Weight" }).positive(),
        /** How large the dog is */
        size: Dogspaces.SizeSchema.describe("Dog Size"),
        /** Age */
        age: z.number({ description: "Dog Age" }).positive(),
        /** Reference to dog picture */
        imageRef: z.string().optional(),
        /** Reference to dog vaccination doc */
        vaccines: z.object(DogVaccines).optional(),
    });
    function Defaults() {
        return {
            name: '',
            size: Sizes.Small,
            breed: '',
            owner: '',
            weight: 1,
            age: 1,
        };
    }
    Dogspaces.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Defaults();
        }
    }
    Dogspaces.CollectionClass = CollectionClass;
    Dogspaces.Collection = new CollectionClass({ path: '/Dogspaces' });
})(Dogspaces || (Dogspaces = {}));
//# sourceMappingURL=index.js.map